/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechListTtsHistory } from "../../funcs/llmSpeechListTtsHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListTextToSpeechHistoryRequest$inboundSchema,
};

export const tool$llmSpeechListTtsHistory: ToolDefinition<typeof args> = {
  name: "llm-speech-list-tts-history",
  description: `List text-to-speech history

List stored text-to-speech generations for the authenticated user, newest first by default.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechListTtsHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
